export default function Container({ children }) {
    return (
        <div className="max-w-8xl px-6 py-6 mx-auto">
            {children}
        </div>
    )
}